import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, RespostaResolvida } from './types';

export const INITIAL_STATE: RespostaResolvida = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): RespostaResolvida {
	return produce(state, draft => {
		switch (action.type) {
			case Types.RESPOSTA_RESOLVIDA_REQUEST: {
				break;
			}
			case Types.RESPOSTA_RESOLVIDA_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.RESPOSTA_RESOLVIDA_FAILURE: {
				draft.status = 400;
				draft.data = action.payload;
				break;
			}
			case Types.RESPOSTA_RESOLVIDA_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
